<i18n>
  {
    "pt_BR": {
      "title": "Informações básicas",
      "description": "Vamos começar! É bem simples, primeiro precisamos dos seus dados básicos: nome, e-mail e celular.",
      "rd": "Entrar com RD Station",
      "back": "Voltar",
      "next": "Próximo",
      "finish": "Finalizar",
      "registered": "Já possuo cadastro.",
      "login": "Quero entrar.",
      "busy": "Cadastrando...",
      "ready": {
        "title": "Cadastro completado com sucesso!",
        "description": "Você já pode fazer o Login na sua conta do RD SMS!",
        "login": "Ir para tela de Login"
      }
    }
  }
</i18n>

<template>
  <section class="signup">
    <form class="signup-form" v-if="ready">
      <header class="signup-form--header">
        <h2 id="signupFormTitle" class="signup-form--header-title" v-t="'ready.title'"></h2>
        <p id="signupFormDesc" class="signup-form--header-desc" v-t="'ready.description'"></p>

        <div class="signup-form--buttons" style="max-width:Inherit">
          <router-link :to="{ path: '/auth/login' }" class="signup-form--button" v-t="'ready.login'" style="margin: 0 auto" />
        </div>
      </header>
    </form>

    <form class="signup-form" @submit.prevent="submit" v-else>
      <header class="signup-form--header">
        <h2 id="signupFormTitle" class="signup-form--header-title" v-t="'title'"></h2>
        <p id="signupFormDesc" class="signup-form--header-desc" v-t="'description'"></p>
        <div id="signupFormProgress" class="signup-form--progressbar">
          <div class="progress--circle step-1 active"></div>
          <div class="progress--circle step-2" :class="{ 'active': step > 0 }"></div>
          <div class="progress--circle step-3" :class="{ 'active': step > 1 }"></div>
          <div class="progress--line active" :class="{ 'step-1': step > 0, 'step-2': step > 1 }"></div>
          <div class="progress--line step-1"></div>
        </div>
      </header><!-- // Form Header -->

      <!-- Form Steps -->
      <div class="signup-form--steps">

        <step-first :form="steps[0]" v-if="step < 1" />
        <step-second :form="steps[1]" v-else-if="step < 2" />
        <step-third :form="steps[2]" v-else />

      </div>

      <!-- Form Buttons -->
      <div class="signup-form--buttons">
        <button @click.prevent id="rdStationLogin" class="signup-form--button button--disabled" v-if="step == 0" v-t="'rd'"></button>
        <a @click.prevent="step -= 1" id="prevStep" class="signup-form--button-link" v-else v-t="'back'"></a>
        <button id="nextStep" class="signup-form--button" type="submit" v-t="steps[2].busy ? 'busy' : step < 2 ? 'next' : 'finish'"></button>
      </div><!-- // Form Buttons -->

      <div class="signup-form--links">
        <p class="signup-form--text">
          {{ $t('registered') }}

          <router-link :to="{ path: '/auth/login' }" class="signup-form--link" v-t="'login'" />
        </p>
      </div>

    </form>
  </section>
</template>

<script>
  import Form from 'core/form';
  import Axios from 'core/axios';
  import StepFirst from './Steps/First';
  import StepSecond from './Steps/Second';
  import StepThird from './Steps/Third';

  export default {
    components: {
      StepFirst,
      StepSecond,
      StepThird,
    },

    data: () => ({
      step: 0,
      ready: false,
      steps: [
        Form.from(['name', 'email', 'phone', 'country']),
        Form.from(['utiliza-rd', 'plano-rd', 'no-rd']),
        Form.from(['password', 'password_confirmation']),
      ],
    }),

    methods: {
      submit () {
        if (this.step == 2) {
          return this.register();
        }

        Axios.post('auth/validate/' + this.step, this.steps[this.step].run())
          .then(() => this.step += 1)
          .catch(err => this.steps[this.step].update(err));
      },

      register () {
        return Axios.post('auth/register', Object.assign({}, ...this.steps.map(form => form.run())))
          .then(() => this.ready = true)
          .catch(err => this.steps.map(form => form.update(err)));
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Auth/Register.vue